import React, { Component } from "react";
import { request } from "../lib/requests";
import {
  CheckboxControl,
  SelectControl,
  InputControl,
  validateRequired,
  validateEmail,
  validateEmailStartPeriods,
  validateEmailEndPeriods,
  validateEmailDoublePeriods,
  validateContainChars,
  validatePhone,
  validateZip,
  validateMin,
  validateMax,
  validateEmpty,
  validatePassword,
  USStateFieldOptions
} from "wvus-forms";

const StateFieldOptions = USStateFieldOptions.map((opt, i) =>
  i === 0 ? { ...opt, valueText: "Select a state" } : opt
);

class CreateSupporterForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      submissionError: false,
      loading: false
    };

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  handleFormSubmit(e) {
    e.preventDefault();
    this.setState({ loading: true });
    // fail safe to bail if they get around disabled button
    if (!this.props.formMethods.isFormValid()) return false;

    const formState = this.props.formMethods.getFormState().fields;
    const formData = {};
    Object.keys(formState).forEach(fieldName => {
      formData[fieldName] = formState[fieldName].value;
    });

    this.createSupporter(formData)
      .then(response => {
        if (!response.success) {
          if(typeof response.code !== "undefined" && response.code == 409) {
            const message = `We already have an login account, please sign in with ${formData['wv-create-account-form-user']}` ;
            window.location.href = this.getLoginURL("", message);
            return;
          }

          const message =
            response.statusCode && response.error && response.message
              ? `Code: ${response.statusCode}, Error: ${
                  response.error
                }, Message: ${response.message}`
              : "An error occurred";
          throw new Error(message);
        }
        this.props.setForm("Confirmation", formData['wv-create-account-form-user']);
      })
      .catch(error => {
        console.error(error);
        this.setState({
          errorMessage: "Something went wrong on our end. Please try again, or call us at 1-888-511-6548 if this continues.",
          submissionError: true,
          loading: false
        });
      });
  }

  async createSupporter(formData = {}) {
    const data = {
      _wpnonce: window.wvusApiSettings.nonce,
      ...formData
    };
    const response = await request
      .post("api/wvus/create_account/create_supporter", data);
    return response.data;
  }

  render() {
    const { formMethods, supporterEmail } = this.props;
    const { loading, submissionError, errorMessage } = this.state;
    const submitDisabled = !formMethods.isFormValid() || loading;

    const loadingIcon = loading ? (
      <span>
      <i className="fa fa-spinner fa-pulse fa-fw" />
      <span className="sr-only">Loading...</span>
      </span>
    ) : (
      ""
    );

    return (
      <form
        id="wv-create-supporter-form"
        className="wv-create-supporter-form wvus-form"
      >
        <InputControl
          fieldName="wv-create-account-form-first-name"
          fieldTitle="First Name"
          formMethods={formMethods}
          validators={[validateRequired, validateContainChars, validateMax(32)]}
        />
        <InputControl
          fieldName="wv-create-account-form-last-name"
          fieldTitle="Last Name"
          secondInteraction={false}
          formMethods={formMethods}
          validators={[validateRequired, validateContainChars, validateMax(32)]}
        />
        <InputControl
          fieldName="wv-create-account-form-address1"
          fieldTitle="Address"
          secondInteraction={false}
          formMethods={formMethods}
          validators={[validateRequired, validateMax(100)]}
        />
        <InputControl
          fieldName="wv-create-account-form-address2"
          fieldTitle="Apt, suite, etc."
          optional={true}
          isValid={true}
          secondInteraction={false}
          formMethods={formMethods}
          validators={[validateRequired, validateMax(100)]}
        />
        <InputControl
          fieldName="wv-create-account-form-city"
          fieldTitle="City"
          secondInteraction={false}
          formMethods={formMethods}
          validators={[validateRequired, validateContainChars, validateMax(50)]}
        />

        <SelectControl
          fieldName="wv-create-account-form-state"
          fieldOptions={StateFieldOptions}
          fieldTitle="State"
          formMethods={formMethods}
          validators={[validateRequired, validateMin(2)]}
        />
        <InputControl
          fieldName="wv-create-account-form-postal-code"
          fieldTitle="Zip"
          fieldType="tel"
          formMethods={formMethods}
          validators={[validateRequired, validateZip]}
        />
        <InputControl
          isValid={true}
          fieldValue="United States"
          fieldName="wv-create-account-form-country"
          fieldTitle="Country"
          fieldClasses="create-account__country-field"
          formMethods={formMethods}
          validators={[validateRequired]}
          attributes={{ readOnly: true, disabled: true }}
        />
        <InputControl
          isValid={true}
          fieldValue={supporterEmail}
          fieldName="wv-create-account-form-user"
          fieldTitle="Email"
          formMethods={formMethods}
          validators={[validateRequired, validateEmail, validateEmailStartPeriods, validateEmailEndPeriods, validateEmailDoublePeriods]}
          attributes={{ readOnly: true, disabled: true }}
        />
        <InputControl
          fieldName="wv-create-account-form-phone"
          fieldTitle="Phone"
          fieldType="tel"
          formMethods={formMethods}
          validators={[validateRequired, validatePhone]}
        />

        <InputControl
          fieldName="wv-create-account-form-pass"
          fieldTitle="Create a password"
          fieldType="password"
          formMethods={formMethods}
          validators={[validateRequired, validatePassword]}
        />
        <p className="create-account__password-hint">
          At least 8 characters with a number, an uppercase letter, and a lowercase letter.
        </p>

        {submissionError ? (
          <p className="wv-create-account-error-message error-message" role="alert" aria-live="assertive">
            {errorMessage}
          </p>
        ) : (
          ""
        )}

        <button
          type="submit"
          id="wv-create-account-form-submit"
          className="create-account__submit"
          disabled={submitDisabled}
          onClick={this.handleFormSubmit}
        >
          {loadingIcon} Create Account
        </button>
      </form>
    );
  }
}
export { CreateSupporterForm };
